import { httpClient } from '../core/http';
import { AppTemplate } from '../types';

type AppTemplateListResponse = {
  items: AppTemplate[];
  count: number;
};

type AppTemplateListParams = {
  search?: string;
  domain?: string;
  include_inactive?: boolean;
};

export class AppTemplateService {
  private readonly basePath = '/v1/app-templates';

  async list(params?: AppTemplateListParams): Promise<AppTemplateListResponse> {
    const response = await httpClient.get<AppTemplateListResponse>(this.basePath, {
      params: params || {},
    });
    return response.data;
  }

  async getBySlug(slug: string): Promise<AppTemplate> {
    const response = await httpClient.get<AppTemplate>(`${this.basePath}/${slug}`);
    return response.data;
  }
}

export const appTemplateService = new AppTemplateService();
